"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EyeClosedSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var EyeClosedSVG = function EyeClosedSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27.8 6.4a1 1 0 00-1.4-.2l-2.7 2.2C13.7 2 5.6 10.1 2.5 13.7a2 2 0 000 2.6 27.2 27.2 0 005.4 5l-3.5 3a1 1 0 00-.2 1.3 1 1 0 00.8.4 1 1 0 00.6-.2l4.1-3.4 2.8-2.3 2.7-2.2 3.8-3 2.6-2.1 3.8-3.1 2.2-1.9a1 1 0 00.2-1.4zm-11.5 8a1.5 1.5 0 01.6-2.3 3 3 0 00-.9-.1 3 3 0 00-3 3 3 3 0 00.6 1.7l-2.4 2a6 6 0 019.3-7.7zM29.5 13.7a33.7 33.7 0 00-2.6-2.8L22 15a6 6 0 01-6 6 5.6 5.6 0 01-1.2-.1l-3 2.4c8.3 2.9 15-3.8 17.7-7a2 2 0 000-2.6z"
  }));
};
exports.EyeClosedSVG = EyeClosedSVG;
EyeClosedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EyeClosedSVG);
exports.default = _default;